import * as React from 'react';
import { ReactNode } from 'react';
import { Route } from 'react-router-dom';
import { Redirect, Switch } from 'react-router';
import LoginPageContainer from '../login/LoginContainer';
import LandingPageContainer from '../landingPage/LandingPageContainer';
import SignUpPageContainer from '../signup/SignUpPageContainer';
import ContactPageContainer from '../contactus/ContactContainer';
import ForgotLinkPageContainer from '../forgotPasswordLinkPage/ForgotLinkPageContainer';
import ForgotPageContainer from '../forgotPasswordPage/ForgotPageContainer';
import ErrorContainer from '../../error/ErrorContainer';
import TermsAndConditionView from '../layouts/TermsAndCondition';
import PrivacyPolicyView from '../layouts/PrivacyPolicyView';

class AppViewInitializer extends React.Component {
  render(): ReactNode {
    return (
      <Switch>
        <Route exact path="/login" component={LoginPageContainer} />
        <Route path="/app" component={LandingPageContainer} />
        <Route exact path="/signup" component={SignUpPageContainer} />
        <Route exact path="/contact" component={ContactPageContainer} />
        <Route exact path="/forgotPassword" component={ForgotLinkPageContainer} />
        <Route exact path="/termsandconditions" component={TermsAndConditionView} />
        <Route exact path="/privacypolicy" component={PrivacyPolicyView} />
        <Route exact path="/resetPassword" component={ForgotPageContainer} />
        <Route exact path="/error" component={ErrorContainer} />
        <Redirect exact from="/" to="/login" />
        <Redirect to="/error" />
      </Switch>
    );
  }
}

export default AppViewInitializer;



// WEBPACK FOOTER //
// ./src/components/layouts/AppViewInitializer.tsx